import {TransitionProps} from "@mui/material/transitions";
import React, {FC} from "react";
import {alpha, Breakpoint, Dialog, DialogActions, DialogContent, Skeleton, Slide, Theme} from "@mui/material";
import {getRandomNumber} from "../../../util/utils";
import CustomDialogTitle from "./custom-dialog-title/CustomDialogTitle";
import {useTheme} from "@mui/material/styles";
import {SxProps} from "@mui/system";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
    open: boolean
    handleDialogClose: () => void
    title?: string
    content: React.ReactElement
    actions?: React.ReactElement
    loading?: boolean
    error?: boolean
    maxWidth?: Breakpoint
    sx?: SxProps<Theme>
    contentSx?: SxProps<Theme>
}

const CustomDialog: FC<Props> = ({
                                     loading = false,
                                     error = false,
                                     actions = <></>,
                                     maxWidth = 'sm',
                                     ...props
                                 }) => {
    const theme = useTheme()

    return (
        <Dialog TransitionComponent={Transition}
                open={props.open}
                fullWidth
                maxWidth={maxWidth}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: alpha(theme.palette.secondary.main, .6),
                            backdropFilter: 'blur(2px)'
                        },
                    },
                }}
                onClose={props.handleDialogClose}>
            {props.title ? <CustomDialogTitle onClose={props.handleDialogClose}>
                {loading ? <Skeleton width={`${getRandomNumber(20, 60)}%`} animation='wave'/> : props.title}
            </CustomDialogTitle> : null}
            <DialogContent sx={props.contentSx}>
                {props.content}
            </DialogContent>
            <DialogActions sx={{px: 3, py: 1.5}}>
                {actions}
            </DialogActions>
        </Dialog>
    )
}

export default CustomDialog
